import { initGlobalTrigger } from './triggers/global_trigger'
import { initItemTriggers } from './triggers/item_trigger'

function main() {
    initGlobalTrigger()
    initItemTriggers()
}

main()
console.log('[ScriptLogic] - Loaded')
